/**
 * NA页面链接保存
 */

// 医生端首页
export const MUZHI_MAIN = 'mzdoctor://muzhi.baidu.com/doctorapp/index';

// 医疗执业资质认证页
export const MUZHI_REGISTAUTH = 'mzdoctor://muzhi.baidu.com/doctorapp/registauth';
